export class FileSizeValidator {
    static validateSize(fileId, maxSizeInMB) {
        let fi = document.getElementById(fileId);
        return FileSizeValidator.validateSizeForInput(fi, maxSizeInMB, null, null);
    }
    static validateSizeForInput(fi, maxSizeInMB, title = null, message = null) {
        if (maxSizeInMB && maxSizeInMB > 0) {
            if (fi.files && fi.files.length > 0) {
                for (let i = 0; i <= fi.files.length - 1; i++) {
                    let file = fi.files.item(i);
                    if (file) {
                        let result = file.size <= maxSizeInMB * 1024 * 1024;
                        if (!result && title && message) {
                            SwalEx.alertCustom(title, message, null, true, 'fal fa-triangle-exclamation status-warning');
                        }
                        return result;
                    }
                }
            }
        }
        return true;
    }
}
window.FileSizeValidator = FileSizeValidator;
